import { HackleUser } from "../../model/model"
import WorkspaceConfig from "./WorkspaceConfig"
import WorkspaceConfigFetcher from "./WorkspaceConfigFetcher"
import { WorkspaceMetadata } from "../Workspace"

/**
 * A no-op local workspace fetcher. Used for config-introspection reads in remote evaluation mode,
 * where the on-device workspace config is not loaded; callers fall back to their defaults.
 */
export class NoopWorkspaceConfigFetcher implements WorkspaceConfigFetcher {
  metadata(): WorkspaceMetadata | null {
    return null
  }

  workspace(_user: HackleUser): WorkspaceConfig | null {
    return null
  }
}
